import { render, staticRenderFns } from "./PedidosFueraMeta.vue?vue&type=template&id=084bbaf0&scoped=true"
import script from "./PedidosFueraMeta.vue?vue&type=script&lang=js"
export * from "./PedidosFueraMeta.vue?vue&type=script&lang=js"
import style0 from "./PedidosFueraMeta.vue?vue&type=style&index=0&id=084bbaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084bbaf0",
  null
  
)

export default component.exports